/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { NumberFieldDisplay } from "./display";
import { NumberFieldEdit } from "./edit";

const NumberField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <NumberFieldDisplay />,
        editComponent: <NumberFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
NumberField.displayName = "NumberField";
export { NumberField };
